/**
 * 商品基础信息登录 api
 */
import Vue from "vue";
import axios from '@/utils/http';
import axiosExample from 'axios';
const api = {
  //商品历史记录查询-初始化模板结构接口
  inittemplate() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itemhis/inittemplate`, {
      mask:false,
    });
  },
  //商品基础信息查询-列表数据查询
  search(_param) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itemhis/s-grid`, {
      mask:false,
      params: _param
    });
  },

}

export default api;



// WEBPACK FOOTER //
// ./src/api/itemHis.js